// extracted by mini-css-extract-plugin
module.exports = {"replica":"Replica_replica-1k7pB","replicaContainer":"Replica_replicaContainer-1Fo3b","start":"Replica_start-qjV8z","end":"Replica_end-1Paaf"};